async function encryptStringWithRsaPublicKey(toEncrypt, publicKey) {
	const { default: JSEncrypt } = await import('jsencrypt');
	const encrypt = new JSEncrypt();
	encrypt.setPublicKey(publicKey);
	return encrypt.encrypt(toEncrypt);
}

export default encryptStringWithRsaPublicKey;
